<section class="verificacao-seguranca-identificacao">
  <img src="assets/images/verify_valid_user.svg" width="160" alt="selfie" />

  <div class="verificacao-seguranca-identificacao__title">Identificação</div>

  <p>Primeiro, precisamos confirmar seus dados pessoais</p>

  <form [formGroup]="form" class="forms">
    <div class="mb-8">Confirme seu CPF:</div>
    <label for="verificacao-cpf" [class.has-value]="form?.controls['cpf']?.value?.length > 0">
      <span *ngIf="form?.controls['cpf']?.value?.length > 0" class="placeholder"
        >Número do seu CPF
      </span>
      <input
        id="verificacao-cpf"
        class="form-control"
        type="text"
        placeholder="Número do seu CPF"
        required
        mask-number
        mask="999.999.999-99"
        appCpfValidator
        appShowErrorMessages
        requiredMessage="O campo CPF é obrigatório"
        formControlName="cpf"
        name="cpf"
      />
    </label>
  </form>
</section>
